import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deletePushToken } from 'shared/services/backend-api/delete-push-token';

import { queryKey as cacheQueryKey } from './use-cached-push-notification-token-query';

export const useDeletePushNotificationMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ token }: { token: string }) => {
      await deletePushToken(token);
      await client.invalidateQueries({ queryKey: [cacheQueryKey] });
    },
  });
};
